module.exports = "/_next/static/images/prepaid-card-big-2328ccdfc21571965ec763c0062d969e.svg";